<template>
  <header class="cx-sec m-header">
    <div class="cx-wrap--page">
      <div  v-if="!isMobileView" class="cx-row--line m-submenu -shown-md cx-t02">
        <div>
          <main-header-weather-status />
        </div>
        <nav class="desktop" role="navigation" id="main-desktop-nav" :aria-label="$t('home.home')">
          <ul class="cx-list cx-list--sep m-list--sep">
            <li class="cx-list__item">
              <router-link-localed to="/video-playlists" class="cx-link"
              >{{$t('videoGallery.videoGallery')}}</router-link-localed>
            </li>
            <li v-if="$t('accessibility.barrierFreeTravelGuide')" class="cx-list__item">
              <router-link-localed to="/barrier-free-access-guide" class="cx-link"
              >{{$t('accessibility.barrierFreeTravelGuide')}}</router-link-localed>
            </li>
            <li class="cx-list__item">
              <a :href="`https://www.dst.gov.mo/${['zh-hant','zh-hans','pt','en'].includes($i18n.locale) ? $i18n.locale : 'en'}/home.html`" rel="noopener noreferrer" target="_blank" class="cx-link">
                {{$t('header.industryNet')}}
              </a>
            </li>
            <li class="cx-list__item">
              <font-size-selector />
            </li>
            <li class="cx-list__item">
              <language-selector />
            </li>
            <li class="cx-list__item">
              <main-header-search-btn />
            </li>
          </ul>
        </nav>
      </div>
      <div class="cx-row--line m-menu" >
        <div>
          <template v-if="($route.name || '').startsWith('Home_')">
            <h1 class="sr-only">{{$t('home.home')}}</h1>
          </template>
          <router-link-localed :aria-label="$t('home.home')" class="theme-logo"
            :to="{name: `Home_${$i18n.locale}`}"
          >
            <span class="sr-only">{{$t('footer.contactOffice')}}</span>
            <cx-img
              tag="span"
              :imgSrc="'/static/logo/raem.svg'"
              class="theme-logo__img m-header__govlogo"
              svg
              ignoreBnw
            ></cx-img><cx-img
              tag="span"
              :key="`${$i18n.locale == 'ar' ? 'ar' : ''}_mgto_logo`"
              :imgSrc="$i18n.locale == 'ar' ? '/static/logo/mgto-logo-ar.svg' : '/static/logo/mgto-logo.svg'"
              class="theme-logo__img m-header__logo"
              svg
            ></cx-img>
          </router-link-localed>
        </div>
        <nav role="navigation" id="main-common-nav" :aria-label="$t('common.menu')">
          <ul class="cx-list m-menu__list -shown-md">
            <li class="cx-list__item m-menu__list-item">
              <a class="cx-link"
                href='https://tripplanner.macaotourism.gov.mo/'>
                <span>{{ $t('trip.smartTripPlanner') }}</span>
              </a>
            </li>
            <li class="cx-list__item m-menu__list-item">
              <a class="cx-link"
                href='#'
                data-keepcollapse="1"
                aria-haspopup="true"
                :aria-expanded="activingCollapse == COLLAPSE.PLAN_YOUR_TRIP ? 'true' : 'false'"
                @keydown.esc="activingCollapse = ''"
                @click.prevent="activeCollapse(COLLAPSE.PLAN_YOUR_TRIP)">
                <span>{{$t('header.planYourTrip')}}</span>
                <span aria-hidden="true" class="cx-link__icon m-link__icon ">
                  <i :class="`fas fa-angle-${activingCollapse == COLLAPSE.PLAN_YOUR_TRIP ? 'down' : 'right' }`"></i>
                </span>
              </a>
              <transition name="header-collapse">
                <main-header-collapse 
                  @keydown.esc.native="activingCollapse = ''"
                  v-if="activingCollapse == COLLAPSE.PLAN_YOUR_TRIP">
                  <component :is="COLLAPSE.PLAN_YOUR_TRIP" 
                    :key="topViewSightLoad ? 'with-tv': 'without-tv'"
                    :travelEssentialMenu="travelEssentialMenu"/>
                </main-header-collapse>
              </transition>
            </li>
            <li class="cx-list__item m-menu__list-item">
              <a class="cx-link"
                href="#"
                data-keepcollapse="1"
                aria-haspopup="true"
                :aria-expanded="activingCollapse == COLLAPSE.EXPERIENCE ? 'true' : 'false'"
                @keydown.esc="activingCollapse = ''"
                @click.prevent="activeCollapse(COLLAPSE.EXPERIENCE)">
                <span>{{$t('header.experience')}}</span>
                <span aria-hidden="true" class="cx-link__icon m-link__icon ">
                  <i :class="`fas fa-angle-${activingCollapse == COLLAPSE.EXPERIENCE ? 'down' : 'right' }`"></i>
                </span>
              </a>
              <transition name="header-collapse">
                <main-header-collapse 
                  @keydown.esc.native="activingCollapse = ''"
                  v-if="activingCollapse == COLLAPSE.EXPERIENCE">
                  <component :is="COLLAPSE.EXPERIENCE" 
                    :key="topViewSightLoad ? 'with-tv': 'without-tv'"
                    :experienceMenu="experienceMenu"/>
                </main-header-collapse>
              </transition>
            </li>
            <li class="cx-list__item m-menu__list-item">
              <router-link-localed to="/dining" class="cx-link"
              >{{$t('header.diningOut')}}</router-link-localed>
            </li>
            <li class="cx-list__item m-menu__list-item">
              <router-link-localed to="/whatson" class="cx-link"
              >{{$t('enf.whatsOn')}}</router-link-localed>
            </li>
            <!-- <li class="cx-list__item m-menu__list-item">
              <router-link-localed to="/events" class="cx-link"
              >{{$t('enf.enf')}}</router-link-localed>
            </li> -->
            <li class="cx-list__item m-menu__list-item">
              <router-link-localed to="/accommodation" class="cx-link"
              >{{$t('header.accommodation')}}</router-link-localed>
            </li>
          </ul>
          <main-header-mobile
            v-if="isMobileView"
            :travelEssentialMenu="travelEssentialMenu"
            :experienceMenu="experienceMenu"
          ></main-header-mobile>
        </nav>
      </div>
    </div>
  </header>
  <!-- header end -->
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import FontSizeSelector from '@/components/FontSizeSelector';
import LanguageSelector from '@/components/LanguageSelector';
import MainHeaderCollapse from '@/components/MainHeaderCollapse';
import MainHeaderCollapsePlanYourTrip from '@/components/MainHeaderCollapsePlanYourTrip';
import MainHeaderCollapseExperience from '@/components/MainHeaderCollapseExperience';
import MainHeaderSearchBtn from '@/components/MainHeaderSearchBtn';
import MainHeaderWeatherStatus from '@/components/MainHeaderWeatherStatus';
import MainHeaderMobile from '@/components/MainHeaderMobile';

export default {
  name: 'main-header',
  asyncData({ i18n, store, route }) {
    return Promise.all([
      store.dispatch('experience/FETCH_MENU', { locale: i18n.locale }),
      store.dispatch('travelessential/FETCH_MENU', { locale: i18n.locale })
    ]);
  },
  lazyData({ i18n, store, route }) {
    store.dispatch('weather/FETCH_WEATHER');
  },
  uit() {
    return [
      ['home', ['home']],
      ['common', ['menu']],
      ['videoGallery', [
        'videoGallery',
      ]],
      ['enf', [
        'enf',
        'whatsOn',
      ]],
      ['trip',['smartTripPlanner']],
      ['header', [
        'industryNet',
        'planYourTrip',
        'experience',
        'diningOut',
        'accommodation'
      ]],
      ['seo', ['defaultDesc']],
      ['accessibility', ['barrierFreeTravelGuide']],
    ];
  },
  data() {
    return {
      activingCollapse: '',
      topViewSightLoad: false,
      weatherUpdatingBreif: true,
      weatherUpdater: null
    }
  },
  computed: {
    ...mapState({
      isMobileView: state => state.ui.isMobileView,
    }),
    popularAttractions: function() {
      return this.$store.getters['attraction/getPopular'](this.$i18n.locale);
    },
    experienceMenu: function() {
      const menu = this.$store.getters['experience/getMenu'](this.$i18n.locale);
      menu.forEach(m => {
        let { category } = m;
        let pa = this.popularAttractions.find(p => p.category == category);
        if (pa && pa['attractions'] && pa['attractions'][0]) {
          m.topViewSight = {...pa['attractions'][0]} 
        }
      })

      return menu;
    },
    travelEssentialMenu: function() {
      const menu = this.$store.getters['travelessential/getMenu'](this.$i18n.locale);

      return menu;
    },
    COLLAPSE: function() {
      return {
        PLAN_YOUR_TRIP: 'main-header-collapse-plan-your-trip',
        EXPERIENCE: 'main-header-collapse-experience'
      }
    }
  },
  components: {
    FontSizeSelector,
    LanguageSelector,
    MainHeaderCollapse,
    MainHeaderCollapsePlanYourTrip,
    MainHeaderCollapseExperience,
    MainHeaderSearchBtn,
    MainHeaderWeatherStatus,
    MainHeaderMobile
  },
  mounted() {
    window.addEventListener('click', this.collpaseClickHandler);
    this.preloadImage('/static/graphic/mgto_graphic_menu_experience.png');
    this.preloadImage('/static/graphic/mgto_graphic_menu_planyourtrip.png');
    this.bootWeatherUpdater();
  },
  beforeDestroy() {
    window.removeEventListener('click', this.collpaseClickHandler);
    this.weatherUpdater && clearInterval(this.weatherUpdater);
  },
  methods: {
    bootWeatherUpdater: function() {
      console.log('[WEATHER] updater botting');
      const isWeahterPage = this.$route
        && typeof this.$route.name == 'string' 
        && this.$route.name.indexOf('Weather') == 0;

      if (isWeahterPage == this.weatherUpdatingBreif) {
        this.weatherUpdatingBreif = !this.weatherUpdatingBreif;
        this.cancelWeatherUpdater();
        this.startWeatherUpdater();
      }

      if (this.weatherUpdater == null) {
        this.cancelWeatherUpdater();
        this.startWeatherUpdater();
      }
    },
    startWeatherUpdater: function() {
      console.log('[WEATHER] updater start');
      this.weatherUpdater = setInterval(() => {
        this.$store.dispatch(`weather/FETCH_WEATHER${this.weatherUpdatingBreif ? '' : '_DETAIL'}`, {
          locale: this.$i18n.locale
        });
      }, 60000)
    },
    cancelWeatherUpdater: function() {
      console.log('[WEATHER] updater cancel');
      this.weatherUpdater && clearInterval(this.weatherUpdater);
    },
    collpaseClickHandler: function(e) {
      let { target } = e;
      let path = this.getDOMPath(target);
      let keep = false;
      let isInCollapse = path.findIndex(dom => dom.className && dom.className.includes && dom.className.includes('m-collapse'));
      if (isInCollapse > -1) keep = true;
      let a = path.findIndex(dom => dom.tagName == 'A' || dom.tagName == 'BUTTON');
      if (a > -1) keep = path[a].dataset && !!path[a].dataset.keepcollapse;
      if (!keep) {
        this.activingCollapse = "";
      }
    },
    activeCollapse: function(collapseName) {
      if (this.activingCollapse == collapseName) {
        this.activingCollapse = '';
        return ;
      }
      this.activingCollapse = collapseName;
    },
  },
  watch: {
    '$route.name': {
      immediate: true,
      handler: function() {
        this.weatherUpdater != null && this.bootWeatherUpdater()
      }
    },
    isMobileView(isMobileView) {
      if (isMobileView) {
        this.activingCollapse = '';
      }
    },
    experienceMenu: {
      deep: true,
      immediate: true,
      handler: function(val) {
        let isTopLoad = this.experienceMenu[0] && this.experienceMenu[0].topViewSight;
        this.topViewSightLoad = !!isTopLoad;
      }
    }
  }
}
</script>

<style lang="scss">

  .theme-logo{
    width: 40px;
    line-height: 1;
    display: block;
    @media(min-width:1100px){
      width: 320px;
    }
       @media(max-width:1099px){
        width: 100px;
       }
  }
  .m-header{
    position: relative;
    border-top: 5px solid $color-red;
    border-bottom: 1px solid $color-grey;
    &__logo{
      display: inline-block;
      width: 250px;
      background-size: contain;
      // background-image: url('/static/logo/mgto-logo.svg');
      // html[data-mode="bnw"] &  {
      //   background-image: url('/static/logo/mgto-logo-bnw.svg');
      // }
      @media(max-width:1099px){
      width: 45px;
      height: 40px;
      background-size: auto 100%;
      background-position: left;
      padding-top: inherit;
      }
    }
    &__mobileitem{
      // margin-right: .5em;
      @include set-font(.8);
    }
    &__govlogo{
      width: 40px;
      height: 40px;
      display: inline-block;
      background-size: 100%;
      html[dir="ltr"] &{
        margin-right: 10px;     
      }
      html[dir="rtl"] &{
        margin-left: 10px;    
      }
      // background-image: url('/static/logo/raem.svg');
       @media(max-width:1099px){
        padding-top: inherit;         
        html[dir="ltr"] &{
          margin-right: 5px;     
        }
        html[dir="rtl"] &{
          margin-left: 5px;    
        }
       }

      // html[data-mode="bnw"] &  {
      //   background-image: url('/static/logo/raem-bnw.svg');
      // }
    }
     &.cx-sec{
      padding-top: $space-sm;
      padding-bottom: $space-sm;
      @media(min-width:$breakpoint-lg){
        padding-top: $space-base;
        padding-bottom: $space-base;
      }
      @media(max-width:767px){
        padding-bottom: .2rem;
      }
     }
     &__mobilelist{
       @include normalize-link;
        .cx-link__text{
          display: none;
        }
        .cx-link--stack .cx-link__icon{
          margin: 0 $space-xs;
          font-size: 1.5rem;
        }
     }
     &__dropdown-subsection{
       margin-left: -$space-base;
       margin-right: -$space-base;
     }
    &__dropdown-content{
      display: block;
      margin: 0;
      ul{
        padding-left: $space-base;
        padding-right: $space-base;
        li{
          a{
            font-weight: normal;
          }
        }
      }
    }
    &__dropdown-title{
      margin-bottom: $space-sm;
      padding-bottom: $space-sm;
    }
     &__mask{
      background-color: rgba(0, 0, 0, 0.5);
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 100;
     }
     &__mobilemenu{
       display: block;
     }
     &__mobilemenu-main{
       font-weight: bold;
     }
     &__mobilemenu-logo{
      width: 250px;
      height: 35px;
     }
     &__mobilemenu-list{    
      // margin: 0 -1rem 0;
      // padding: 0 1rem 1rem;
      // background: white;
      min-height: 100%;
      &::after{
        content: "";
        background: url("/static/graphic/mgto_graphic_menu_experience.png") right bottom / auto 190px no-repeat;
        display: block;
        padding-top: 70%;
        position: sticky;
        top: 100%;
        transform: translateX(1rem) translateY(1rem);

        html[data-mode="bnw"] & {
          background: url("/static/graphic/mgto_graphic_menu_experience.png?impolicy=bnw") right bottom / auto 190px no-repeat;
        }
      }
     }
     &__mobilemenu-logoimg{
      background-position: 0 center;
      padding-top: 35px;
     }
  }
  .m-submenu{
    align-items: flex-start;
    color: $color-midgrey;
    a{
      // color: $color-midgrey;
      color: #69797E; // A11y
      &:hover{
        color: $color-green;
      }
    }
    .cx-dropdown__content{
      @include set-font(.7);
    }    
  }
  .m-list--sep{
    justify-content: flex-end;
    li{
      &:after{
        top: 4px;
        bottom: 4px;
      }
    }
  }
  .m-link{
    &__icon{
      i{
        width: .5em;
      }
    }
  }
  .m-menu{
    h1{
      margin-bottom: 0;
    }
    &__list{
      line-height: 1.6;
      justify-content: flex-end;
      font-weight: 700;
     li{
       a{
         color: $color-darkgrey;
         font-size: .9rem;

        @media(min-width:1400px){
         font-size: 1.1rem;
        }
         &:hover{
           color: $color-green;
         }
       }
      }
    }
    &__list-item{
      word-wrap: break-word;
      overflow-wrap: break-word;
      -webkit-hyphens: auto;
      -moz-hyphens: auto;
      hyphens: auto;      
    }
    &__list-item::after{
      content: none;
      @media(min-width:1100px){
         content: none;
        }
    }
    &__list-item::before{
      content: "";
      display: inline-block;
      width: 1em;
      @media(min-width:1100px){
         width: 2em;
        }
    }
  }

  .header-collapse-enter-active, .header-collapse-leave-active {
    transition: all .3s;
  }
  .header-collapse-enter, .header-collapse-leave-to {
    max-height: 0 !important;
    padding: 0rem 2rem !important;
  }

  nav.desktop {
    margin-left: 5em;
  }
</style>
